<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="image">
            <defs>
                <path id="vdu3zm2xoa" d="M17.72 4H6.28C5.023 4 4 5.023 4 6.28v11.44C4 18.977 5.023 20 6.28 20h11.44c1.257 0 2.28-1.023 2.28-2.28V6.28C20 5.023 18.977 4 17.72 4zm.987 13.72c0 .544-.443.987-.987.987H6.28c-.544 0-.987-.443-.987-.987V6.28c0-.544.443-.987.987-.987h11.44c.544 0 .987.443.987.987v11.44zM9.14 7.268c-1.032 0-1.872.84-1.872 1.872s.84 1.872 1.872 1.872 1.872-.84 1.872-1.872-.84-1.872-1.872-1.872zm0 2.452c-.32 0-.58-.26-.58-.58 0-.32.26-.58.58-.58.32 0 .58.26.58.58 0 .32-.26.58-.58.58zm10.67 4.274L15.726 9.91c-.252-.253-.661-.253-.914 0l-8.988 8.988c-.252.252-.252.661 0 .914.127.126.292.189.457.189.166 0 .331-.063.457-.19l8.531-8.53 3.629 3.628c.252.253.661.253.914 0 .252-.252.252-.661 0-.914z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="18qphag43b" fill="#fff">
                    <use xlink:href="#vdu3zm2xoa"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#18qphag43b)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-image',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>